<script lang="ts">
  import { onMount, onDestroy } from 'svelte'

  let { words, speed = 1 }: { words: string[]; speed?: number } = $props()

  let marqueeElement: HTMLDivElement | undefined
  let isVisible = $state(false)
  let observer: IntersectionObserver | undefined

  onMount(() => {
    // Create intersection observer to detect when marquee is in view
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          isVisible = entry.isIntersecting
        })
      },
      { threshold: 0.1 }
    )

    if (marqueeElement) {
      observer.observe(marqueeElement)
    }

    return () => {
      observer?.disconnect()
    }
  })

  onDestroy(() => {
    observer?.disconnect()
  })

  // Join words with dots and create enough copies to span screen width
  const joinedText = $derived(words.join(' • '))
  const textCopies = $derived(Array(40).fill(joinedText)) // Increased copies for full screen coverage
</script>

<!-- Decorative: 40 repeats would be read out verbatim by screen readers. -->
<div bind:this={marqueeElement} aria-hidden="true" class="w-full overflow-hidden bg-black py-2">
  <div
    class="text-brand-sand-light flex font-mono text-xs whitespace-nowrap"
    style:animation-play-state={isVisible ? 'running' : 'paused'}
    style:animation-duration={`${String(20 / speed)}s`}
  >
    {#each textCopies as copy, i (i)}
      <span class="mr-8 tracking-[1rem] uppercase">{copy} • </span>
    {/each}
  </div>
</div>

<style>
  @keyframes marquee {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-100%);
    }
  }

  div[style*='animation-duration'] {
    animation: marquee linear infinite;
  }

  @media (prefers-reduced-motion: reduce) {
    div[style*='animation-duration'] {
      animation: none;
    }
  }
</style>
